import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useRef } from 'react';
import { useEnsureRef } from '../../hooks';

const elemId = 'cycle-tape-wrapper';
const Receipt = forwardRef(({ content, languageCode }, ref) => {
	const theme = useTheme();
	const innerRef = useEnsureRef(ref);
	const containerRef = useRef();

	const languageCodes = [
		"he"
	]
	
	const print = () => {
		const elem = document.getElementById(elemId);
		if (elem) {
			const content = `<html><head>
			<style>@import url(/fonts/style.css);</style>
			<style>body{background-color: unset !important; text-align: ${languageCode === 'he' ? 'right' : 'left'};}</style></head><body>${elem.outerHTML || ''}</body></html>`;
			const iframe = document.createElement('iframe');
			document.body.appendChild(iframe);
			const pri = iframe?.contentWindow;
			pri.document.open();
			pri.document.write(content);
			pri.document.close();

			pri.onafterprint = () => {
				try {
					document.body.removeChild(iframe);
				} catch (error) {
					console.error('print remove child error', error);
				}
			};
			pri.focus();
			pri.print();

			return true;
		}
	};

	const download = useCallback(
		(filename = 'Receipt', ext = 'pdf') => {
			const elem = document.getElementById(elemId);
			if (elem) {
				const elemWidth = elem.clientWidth;
				const elemHeight = elem.clientHeight;
				return html2canvas(elem, { scale: 2, quality: 2 }).then((canvas) => {
					const fullFilename = `${filename}.${ext}`;
					const imgData = canvas.toDataURL(`image/${ext === 'pdf' ? 'png' : ext}`);
					if (ext === 'pdf') {
						const pdf = new jsPDF({
							orientation: canvas.width > canvas.height ? 'l' : 'p',
							unit: 'pt',
							format: [elemWidth, elemHeight]
						});

						pdf.addImage(imgData, 'png', 0, 0, elemWidth, elemHeight);
						pdf.save(fullFilename);
					} else {
						const link = document.createElement('a');
						if (typeof link.download === 'string') {
							link.href = imgData;
							link.download = fullFilename;
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
						} else {
							window.open(imgData);
						}
					}
					return imgData;
				});
			}
		},
		[]
	);
	const receiptTexts = useMemo(() => {
		let data = content.split("<PrinterLine> </PrinterLine>");
		if (content) {
			return data.map((item) => {
				item = item
					.replaceAll('<PrinterLines />', '')
					.replace(/<PrinterLine>/g, '')
					.replace(/<PrinterLine\/\>/g, '&nbsp;<br/>')
					.replace(/<\/\PrinterLine>/g, '&nbsp;<br/>')
					.replace(/PrinterLines/g, 'p')
					.replace(/ /g, '&nbsp;');
				return item;
			})
		}
	}, [content]);

	useImperativeHandle(
		innerRef,
		() => ({
			print,
			download
		}),
		[]
	);

	return (
		<Stack
			style={{
				border: receiptTexts ? `1px solid ${theme.palette.divider}` : null,
				marginBottom: theme.spacing(2),
				width: 'fit-content'
			}}
			id={elemId}
			ref={containerRef}
		>
			
			{
				(receiptTexts || []).map((item, index) => {
					return (
							<Typography
							    key={`receipt-text-${index}`}
								style={{ fontSize: 13, fontFamily: 'monospace', marginBottom: 1, textAlign: languageCodes.includes(languageCode) ? 'right' : 'left' }}
								dangerouslySetInnerHTML={{ __html: item }}
								component="span"
								variant="body2"
							/>
					)
				})
			}
		</Stack>
	);
});
export default Receipt;
